export default function ({app: {router}}, inject) {
  if(false){
    // inject empty gtag function for disabled mode
    inject('gtag', () => {})
    return
  }

  window.dataLayer = window.dataLayer || []
  function gtag () {
    dataLayer.push(arguments)
    if(false){
      console.debug('gtag tracking called with following arguments:', arguments)
    }
  }
  inject('gtag', gtag)
  gtag('js', new Date())
  gtag('config','G-1DJZGMW520',)

  if(!false){
    router.afterEach((to) => {
      gtag('config', 'G-1DJZGMW520', {'page_path': to.fullPath})
    })
  }

  // additional accounts

    gtag('config', 'AW-711317830',)
}
